import React from 'react';
import { useFavicon } from '../../ui-toolkit/hooks/useFavicon';
import { useDocumentTitle } from '../../ui-toolkit/hooks/useDocumentTitle';

/**
 * Component that handles dynamic favicon and document title updates based on environment and feature flags.
 * This component renders nothing but executes hooks to update the document head.
 * 
 * Must be mounted inside the Redux Provider so hooks can access the store.
 */
export const FaviconUpdater: React.FC = () => {
  useFavicon();
  useDocumentTitle();
  return null;
};

